import React, { useState, useEffect } from 'react';
import { TextField, InputAdornment, CircularProgress } from '@mui/material';

const WebHookField = ({ webhookUrl, setWebhookUrl, tempTheme, label, name }) => {
  const [debouncedWebhookUrl, setDebouncedWebhookUrl] = useState(webhookUrl);
  const [isAnalyzing, setIsAnalyzing] = useState(false);

  const handleWebhookUrlChange = (event) => {
    const rawValue = event.target.value;
    const cleanValue = rawValue.replace(/[^a-z0-9-]/g, '');
    setDebouncedWebhookUrl(cleanValue);
    setIsAnalyzing(true);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      if (debouncedWebhookUrl !== webhookUrl) {
        setWebhookUrl(debouncedWebhookUrl);
      }
      setIsAnalyzing(false);
    }, 3000);

    return () => clearTimeout(handler);
  }, [debouncedWebhookUrl, webhookUrl, setWebhookUrl]);

  return (
    <TextField
      fullWidth
      label={label}
      name={name}
      value={debouncedWebhookUrl}
      onChange={handleWebhookUrlChange}
      InputProps={{
        startAdornment: <InputAdornment position="start">https://</InputAdornment>,
        endAdornment: (
          <InputAdornment position="end">
            {isAnalyzing && (
              <CircularProgress
                size={16}
                sx={{ marginLeft: 1 }}
              />
            )}
          </InputAdornment>
        ),
      }}
      placeholder="Enter your webhook URL"
      margin="normal"
      variant="outlined"
      sx={tempTheme}
    />
  );
};

export default WebHookField;
